export const actions = {
  SET_IVT_LIST: "SET_IVT_LIST",
  SET_IVT_FILTER: "SET_IVT_FILTER"
};

export const setIvtFilters = (filters) => ({
  type: actions.SET_IVT_FILTER,
  payload: filters
});
